module.exports = __webpack_public_path__ + "img/Introduction.185c535d.svg";